'use client';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
// import Button from "@mui/material/Button";
// import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import * as _ from 'lodash';
import Cookies from 'js-cookie';
import {
  MagnifyingGlassIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  ArrowsUpDownIcon,
  ArrowTopRightOnSquareIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  DeleteIcon,
} from '@heroicons/react/24/outline';
// import mqtt from 'mqtt';
import { useUserContext } from '../contexts/UserContext';
import { set } from 'date-fns';

let signalstopic = 'goldensparrowcapital-signals';

const MeanTheoryComponent = props => {
  const {
    user
  } = useUserContext();
  const [meanTheoryData, setMeanTheoryData] = useState([]);
  const [meanTheoryDataForSymbol, setMeanTheoryDataForSymbol] = useState([]);
  // Store current prices by symbol for efficient updates

  const [client, setClient] = useState(null);
  // const mqttClientRef = useRef(null); // holds the MQTT client instance
  // const mqttListenerAttached = useRef(false); // ensures only one message handler is attached
  const wsRefBinance = useRef(null);
  const [lastUpdated, setLastUpdated] = useState(new Date().valueOf());
  const [popupMeanTheory, setPopupMeanTheory] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [pressure, setPressure] = useState([]);
  const [totalBuys, setTotalBuys] = useState(0);
  const [totalSells, setTotalSells] = useState(0);
  const [minTime, setMinTime] = useState(0);
  const [maxTime, setMaxTime] = useState(0);
  const [pressurePanelOpen, setPressurePanelOpen] = useState(false);
  const [showingSymbol, setShowingSymbol] = useState(null)
  const [pressureDataLastRefreshed, setPressureDataLastRefreshed] = useState(new Date().valueOf())

  useEffect(() => {
    async function fetchData() {
      if (user.userType == "ADMIN") {
        // await _connectMQTT(props);
        await getMeanTheoryData();

      }
    }
    fetchData();
  }, []);

  //i want to call getMeanTheoryData, every hour's 02 minute
  // like 4:02, 5:02, 6:02 etc, fix the code
  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      if (now.getMinutes() === 2) {
        getMeanTheoryData();
      }
    }, 60000); // 60000 ms = 1 minute
    return () => clearInterval(interval);
  }, []);

  //if there is a value in showingSymbol, call the getPressure function every 2 mins
  // useEffect(() => {
  //   if (!showingSymbol) return;
  //   const interval = setInterval(() => {
  //     getPressure(showingSymbol);
  //   }, 1 * 60 * 1000); // every 1 minute
  //   return () => clearInterval(interval);
  // }, [showingSymbol]);

  // const getPressure = async (symbol) => {
  //   try {
  //     setShowingSymbol(symbol)
  //     setPressureDataLastRefreshed(new Date().valueOf())
  //     const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/getPressure`, {
  //       method: 'POST',
  //       credentials: 'include',
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'application/json',
  //       },
  //       body: JSON.stringify({ symbol }),
  //     });

  //     if (!response.ok) {
  //       setPressure([]);
  //       return;
  //     }

  //     const result = await response.json();

  //     if (result.success) {
  //       try {
  //         //  console.log('Pressure fetched successfully:', result.data.length, new Date().toLocaleString());
  //         // Sanitize/normalize incoming pressure items so JSX never tries to render raw objects
  //         const safeData = (Array.isArray(result.data) ? result.data : []).map((item, idx) => {
  //           const safeId = item._id && typeof item._id !== 'string' ? (item._id.toString ? item._id.toString() : JSON.stringify(item._id)) : item._id || String(idx);
  //           const safeCp = typeof item.cp === 'object' && item.cp !== null ? JSON.stringify(item.cp) : (typeof item.cp === 'undefined' ? '' : String(item.cp));
  //           const safeS = typeof item.s === 'object' && item.s !== null ? JSON.stringify(item.s) : (typeof item.s === 'undefined' ? '' : String(item.s));
  //           const safePt = typeof item.pt === 'object' && item.pt !== null ? JSON.stringify(item.pt) : (typeof item.pt === 'undefined' ? '' : String(item.pt));
  //           // Normalize cd to a number (timestamp) if possible
  //           let safeCd = item.cd;
  //           if (typeof safeCd === 'string' || safeCd instanceof String) {
  //             const parsed = Date.parse(safeCd);
  //             safeCd = isNaN(parsed) ? safeCd : parsed;
  //           } else if (safeCd && typeof safeCd === 'object' && safeCd.toString) {
  //             const parsed = Date.parse(String(safeCd));
  //             safeCd = isNaN(parsed) ? safeCd : parsed;
  //           }
  //           return {
  //             ...item,
  //             _id: safeId,
  //             cp: safeCp,
  //             s: safeS,
  //             pt: safePt,
  //             cd: safeCd,
  //           };
  //         });

  //         const totalBuys = safeData.filter(item => item.pt === 'B').length;
  //         const totalSells = safeData.filter(item => item.pt === 'S').length;
  //         setTotalBuys(totalBuys);
  //         setTotalSells(totalSells);
  //         if (safeData.length > 0) {
  //           const cds = safeData.map(item => (typeof item.cd === 'number' ? item.cd : Date.parse(String(item.cd)))).filter(v => !isNaN(v));
  //           setMinTime(cds.length ? Math.min(...cds) : 0);
  //           setMaxTime(cds.length ? Math.max(...cds) : 0);
  //         } else {
  //           setMinTime(0);
  //           setMaxTime(0);
  //         }
  //         setPressure(safeData);
  //         setPressurePanelOpen(true);
  //       } catch (error) {
  //         setPressurePanelOpen(true);
  //         console.error('Error processing pressure data:', error);
  //       }
  //     } else {
  //       console.error('Invalid response format:', data.message || 'Unknown error');
  //     }
  //   } catch (e) {
  //     console.error('Error fetching pressure:', e);
  //   }
  // };

  const getMeanTheoryDataForSymbol = async (symbol) => {
    try {
      setPressurePanelOpen(true);
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/getMeanTheoryDataForSymbol`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ symbol }),
      });

      if (!response.ok) {
        setMeanTheoryDataForSymbol([]);
        return;
      }

      const result = await response.json();
      console.log("Result:", symbol, result);
      if (result.success) {
        console.log("Data for symbol:", symbol, result.data);
        setMeanTheoryDataForSymbol(result.data);
      } else {
        console.error('Invalid response format:', data.message || 'Unknown error');
      }
    } catch (e) {
      console.error('Error fetching mean theory data for symbol:', e);
    }
  };

  const getMeanTheoryData = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/dashboard/getMeanTheoryData`, {
        method: 'GET',
        credentials: 'include',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        setMeanTheoryData([]);

        return;
      }

      const result = await response.json();

      // console.log("Data:", result);

      if (result.success) {
        const groupedData = result.data.reduce((acc, item) => {
          (acc[item.symbol] = acc[item.symbol] || []).push(item);
          return acc;
        }, {});
        const finalResult = Object.keys(groupedData).map(symbol => ({
          symbol,
          data: groupedData[symbol],
          maxCreationDate: Math.max(...groupedData[symbol].map(item => item.creationDate))
        }));
        // console.log(finalResult);
        setMeanTheoryData(finalResult);
        setLastUpdated(new Date().valueOf());

      } else {
        console.error('Invalid response format:', result.message || 'Unknown error');
      }
    } catch (e) {
      console.error('Error fetching open trades:', e);
    }
  };



  // async function handleDelete(uuid) {
  //   // console.log("Deleting PreWatcher:", uuid)
  //   //remove preWatcher from preWatchers state
  //   // setPreWatchers(prevPreWatchers => prevPreWatchers.filter(preWatcher => preWatcher.uuid !== uuid));

  //   const gsccookie = Cookies.get('gsccookie') || null;
  //   console.log("Deleting PreWatcher:", uuid, gsccookie)

  //   client.publish("DELETE_PREWATCHER", JSON.stringify({ token: gsccookie, uuid }), err => {

  //   });
  // }



  // Memoize preWatchers with current prices for rendering

  return meanTheoryData ? (
    <div style={{ borderRadius: 8, width: 'auto' }}>
      <h1 className="text-xs" style={{ margin: 0, paddingTop: 1, color: 'gray', marginBottom: 3 }}>
        Last Updated: {new Date(lastUpdated).toLocaleDateString()} ,{' '}
        {new Date(lastUpdated).toLocaleTimeString()}
      </h1>





      <h1 className="text-sm" style={{ margin: 0, paddingTop: 1, color: '#fff', marginBottom: 3 }}>
        Count: {meanTheoryData.length}
      </h1>


      {meanTheoryData.sort((a, b) => b.maxCreationDate - a.maxCreationDate).map((item, index) => (

        <div key={item.symbol} className="bg-white dark:bg-gray-200" style={{ padding: 5, margin: 5, borderRadius: 10 }}>


          <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>

            
            <div style={{ alignItems: 'center', display: 'flex', gap: 5 }}>
              <h4 style={{ fontWeight: 'bolder', marginLeft: 3, color: "black" }}>{index + 1}. {item.symbol}</h4>

              <button
                style={{
                  backgroundColor: '#7e8082ff',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                  alignItems: 'center', display: 'flex'
                }}
                onClick={() => {
                  window.open(
                    'https://www.coinglass.com/tv/Binance_' + item.symbol,
                    '_blank'
                  )

                }}
              >
                <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>CoinGlass</h4>
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 30 30"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                >
                  {/* Dark background circle matching trading terminal themes */}
                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                  {/* Upward diagonal arrow symbolizing market breakouts and data shifts */}
                  <path
                    d="M10.5 21.5L21.5 10.5M21.5 10.5H13.5M21.5 10.5V18.5"
                    stroke="#ffffff"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />

                  {/* Subtle outer border for depth */}
                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                </svg>

              </button>
              <button
                style={{
                  backgroundColor: '#7e8082ff',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                  alignItems: 'center', display: 'flex'
                }}
                onClick={() => {
                  window.open(
                    'https://www.tradingview.com/chart/?symbol=BINANCE%3A' + item.symbol,
                    '_blank'
                  )

                }}
              >
                <h4 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Trading View</h4>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ display: 'inline', verticalAlign: 'middle', marginLeft: 8 }}
                >
                  {/* Standard Terminal Background */}
                  <circle cx="16" cy="16" r="16" fill="#1E222D" />

                  {/* TradingView 'Chart' Bars - Representing Technical Analysis */}
                  <rect x="9" y="15" width="3" height="7" rx="1" fill="#ffffff" />
                  <rect x="14.5" y="10" width="3" height="12" rx="1" fill="#ffffff" />
                  <rect x="20" y="13" width="3" height="9" rx="1" fill="#ffffff" />

                  {/* Border for UI consistency */}
                  <circle cx="16" cy="16" r="15.5" stroke="#2A2E39" strokeWidth="1" />
                </svg>
              </button>
              <button
                style={{
                  backgroundColor: '#298f09ff',
                  fontSize: 12,
                  borderRadius: 5,
                  padding: 3,
                  alignItems: 'center', display: 'flex',

                }}
                onClick={async () => {
                  await getMeanTheoryDataForSymbol(item.symbol);
                }}
              >
                <h5 style={{ fontWeight: 'bolder', marginLeft: 3 }}>Show more...</h5>


              </button>
              {/* show the maxCreationDate of the symbol in format "Last Updated: 8/30/2024, 4:02:15 PM" just beside the symbol name in smaller font and grey color */}
              <span style={{ fontSize: 11, color: 'black', marginLeft: 5 }}>
                Last Updated: {new Date(item.maxCreationDate).toLocaleString()}
              </span>
            </div>

            {/* The below button should be on the extreme right of the table row and should have a red background with a white cross icon in the center */}

            <button
              style={{
                background: 'red',
                border: 'none',
                borderRadius: 5,
                color: '#fff',
                cursor: 'pointer',
                marginLeft: 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 20,
                height: 20,
                padding: 0,
              }}
              title="Delete"
              onClick={() => {
                alert(`Delete ${item.symbol}`);
              }}
            >
              {/* the cross is not exactly in the middle of red box */}
              {/* can you fix the below svg so that the cross is exactly in the middle of red box */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="none"
                viewBox="0 0 12 12"
                stroke="white"
                style={{ display: 'block', margin: 'auto', alignItems: 'center', justifyContent: 'center' }}
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3l8 8M11 3l-8 8" />
              </svg>
            </button>
          </div>


          <table className="min-w-full bg-white shadow-md rounded-lg" style={{ margin: 5 }}>


            <thead>
              <tr>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>
                  Creation Date
                </th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color:"black" }}>Timeframe</th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Hrs ago</th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Lowest Price</th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Lowest Mean Touched (7,14,30 days)</th>

                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>(Current / Previous) Buy Volume</th>
                {/* <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Previous & Current Sell Volume</th> */}
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>(Previous / Current) Sell Volume</th>

                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>10 Days (Mean High / Current) Sell Volume</th>

                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Checks ( Low Volume, Double RSI Touch)</th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>RSI</th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Aggr Spot CVD, Delta</th>
                <th className="text-sm py-2 px-4 border-b" style={{ marginTop: 2, color: "black" }}>Open Interest</th>


              </tr>
            </thead>
            <tbody>
              {/* show only the latest 15 entries for each symbol and sort them by creation date in descending order */}
              {item.data
                .sort((a, b) => b.creationDate - a.creationDate)
               // .slice(0, 10)
                .map((dataItem, index) => {
                  // const touched7 = dataItem?.mean7Days?.isMeanTouched === 'YES';
                  // const touched14 = dataItem?.mean14Days?.isMeanTouched === 'YES';
                  // const touched30 = dataItem?.mean30Days?.isMeanTouched === 'YES';
                  // if (!touched7 || !touched14 || !touched30) return null;

                  return (
                    <tr key={dataItem.uuid} style={{
                      marginTop: 5,
                      color: "black"
                    }}>
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13 }}>
                        {/* show both the creation date and how long ago it was created vertically, with margin of 5 */}
                        <div style={{ marginBottom: 5 }}>
                          {new Date(dataItem.creationDate).toLocaleString()}
                        </div>
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13 }}>{dataItem?.timeFrame}</td>  
                      {/* <td  className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13 }}>{dataItem.strategyName}</td> */}
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13,  }}>  {Math.floor(((new Date().valueOf()) - dataItem.creationDate) / 3600000)}{" hours ago"}</td>
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13, }}>{dataItem?.lowestPrice}</td>
                      <td className="text-xs py-2 px-4 border-b text-center"
                        style={{
                          fontSize: 13, borderRadius: 5,
                          // backgroundColor : dataItem?.mean7Days?.isLowestRangeTouched === 'YES' &&
                          // dataItem?.mean14Days?.isLowestRangeTouched === 'YES' &&
                          // dataItem?.mean30Days?.isLowestRangeTouched === 'YES' ? '#06ad06ff' : 'transparent',
                          // color : dataItem?.mean7Days?.isLowestRangeTouched === 'YES' &&
                          // dataItem?.mean14Days?.isLowestRangeTouched === 'YES' &&
                          // dataItem?.mean30Days?.isLowestRangeTouched === 'YES' ? 'white' : 'black'
                        }}>
                        {/* {dataItem?.mean2Days?.isLowestRangeTouched === 'YES' ? 'Yes' : 'No'}, */}
                        {dataItem?.mean7Days?.isLowestRangeTouched === 'YES' ? 'Yes' : 'No'},
                        {dataItem?.mean14Days?.isLowestRangeTouched === 'YES' ? 'Yes' : 'No'},
                        {dataItem?.mean30Days?.isLowestRangeTouched === 'YES' ? 'Yes' : 'No'}
                      </td>

                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13, }}>
                      {(dataItem?.volume?.buyVolume || 0).toFixed(0).toLocaleString()} / {(dataItem?.volume?.buyVolumePreviousCandle || 0).toFixed(0).toLocaleString()}
                        = {(dataItem?.volume?.buyVolume / dataItem?.volume?.buyVolumePreviousCandle || 0).toFixed(2).toLocaleString()}
                      </td>
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13, }}>
                        {(dataItem?.volume?.sellVolumePreviousCandle || 0).toFixed(0).toLocaleString()} / {(dataItem?.volume?.sellVolume || 0).toFixed(0).toLocaleString()}
                      = {((dataItem?.volume?.sellVolumePreviousCandle / dataItem?.volume?.sellVolume) || 0).toFixed(2)}
                      </td>
                      {/* <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13,  }}>{((dataItem?.volume?.sellVolumePreviousCandle / dataItem?.volume?.sellVolume) || 0).toFixed(0)}</td> */}
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13,  }}>{(dataItem?.volume?.meanHighestSellVolume10Days || 0).toFixed(0).toLocaleString()} / {(dataItem?.volume?.sellVolume || 0).toFixed(0).toLocaleString()} = {((dataItem?.volume?.meanHighestSellVolume10Days / dataItem?.volume?.sellVolume) || 0).toFixed(2)}</td>


                      <td className="text-xs py-2 px-4 border-b text-center" style={{
                        fontSize: 13, borderRadius: 5,
                        backgroundColor: dataItem?.checks?.check1_lowSellVolume == "YES" &&
                          dataItem?.checks?.check2_doubleRsiTouch == "YES" ? '#06ad06ff' : 'transparent',
                        color: dataItem?.checks?.check1_lowSellVolume == "YES" &&
                          dataItem?.checks?.check2_doubleRsiTouch == "YES" ? 'white' : 'black'
                      }}>
                        {dataItem?.checks?.check1_lowSellVolume == "YES" ? 'Yes' : 'No'},
                        {dataItem?.checks?.check2_doubleRsiTouch == "YES" ? 'Yes' : 'No'}
                      </td>

                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13,  }}>{Number(dataItem?.indicators?.rsi || 0).toFixed(2)}</td>
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13,  }}>{Number(dataItem?.indicators?.aggregateSpotCVD?.aggregatedSpotCVD || 0).toFixed(0)}, {Number(dataItem?.indicators?.aggregateSpotCVD?.delta || 0).toFixed(0)}</td>
                      <td className="text-xs py-2 px-4 border-b text-center" style={{ fontSize: 13, }}>{(dataItem?.indicators?.openInterest || 0).toLocaleString()}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>

        </div>
      ))}


      {pressurePanelOpen && (

        <div
          role="dialog"
          aria-label="Pressure data panel"
          style={{
            position: 'fixed',
            right: 0,
            top: 0,
            bottom: 0,
            width: '400px',
            maxWidth: '100%',
            backgroundColor: '#fff',
            borderLeft: '1px solid #eee',
            padding: 10,
            overflowY: 'auto',
            zIndex: 9999,
            boxShadow: '-4px 0 12px rgba(0,0,0,0.08)',
            transition: 'transform 180ms ease',
            willChange: 'transform',
          }}
        >

          <div style={{
            backgroundColor: "red",
            borderRadius: "5px", placeContent: "center", display: "flex"
          }}>
            <h5 style={{ color: "white", padding: "5px", flex: ".95" }}>{showingSymbol}</h5>

            <button
              style={{
                cursor: "pointer", padding: "5px"
              }}
              onClick={() => {
                setPressurePanelOpen(false);
                setPressure([])
                setShowingSymbol(null)
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="12"
                height="12"
                fill="none"
                viewBox="0 0 12 12"
                stroke="#fff"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3l8 8M11 3l-8 8" />
              </svg>
            </button>
          </div>
          <span style={{ fontSize: 11, color: 'grey', marginLeft: 5 }}>
            Last Updated: {new Date(pressureDataLastRefreshed).toLocaleString()}
          </span>

          <h5 style={{ margin: 3, fontWeight: "bold", color: "green" }}>Total Buys: {totalBuys}</h5>
          <h5 style={{ margin: 3, fontWeight: "bold", color: "red" }}>Total Sells: {totalSells}</h5>
          <h5 style={{ color: "black", margin: 3, fontWeight: "bold" }}>Min Time: {new Date(minTime).toLocaleString()}</h5>
          <h5 style={{ color: "black", margin: 3, fontWeight: "bold" }}>Max Time: {new Date(maxTime).toLocaleString()}</h5>

          {/* Loop through the pressure Data and display order by cd in des order*/}
          <div>
            {pressure && pressure.length > 0 ? (
              pressure
                .slice()
                .sort((a, b) => b.cd - a.cd)
                .map((pItem, index) => {
                  // Use a safe string key (Mongo ObjectId may be an object)
                  const key = pItem._id && (typeof pItem._id === 'string' ? pItem._id : (pItem._id && pItem._id.toString ? pItem._id.toString() : index));
                  return (
                    <div
                      key={key}
                      style={{
                        color: pItem.pt === 'B' ? 'green' : 'red',
                        borderBottom: '1px solid #eee',
                        padding: '6px 0',
                      }}
                    >
                      <strong>{new Date(pItem.cd).toLocaleString()}</strong>
                      <span style={{ marginLeft: 8 }}>
                        • {typeof pItem.cp !== 'undefined' ? String(pItem.cp) : ''}
                      </span>
                    </div>
                  );
                })
            ) : (
              <p style={{ color: 'red' }}>No pressure entries</p>
            )}
          </div>
        </div>
      )}
    </div>

  ) : null;
};


export default MeanTheoryComponent;
